// @ts-check
import React, { Component } from "react"
import { css } from "react-emotion"

const error = css`
    background: red;
    border-radius: 50%;
    padding: 5px;
    display: inline-block;
    color: white;
    width: 15px;
    height: 15px;
    text-align: center;
    position: absolute;
    left: -20px;
    top: -10px;
`
const warning = css`
    background: orange;
    border-radius: 50%;
    padding: 5px;
    display: inline-block;
    color: white;
    width: 15px;
    height: 15px;
    text-align: center;
    position: absolute;
    left: -20px;
    top: -10px;
`

function DisplayCounter({ errors, warnings }) {
    if (errors.length) return <div className={error}>{errors.length}</div>
    return <div className={warning}>{warnings.length}</div>
}

/**
 * @augments {Component<{validation: {errors: Broadcast_Validation[], warnings: Broadcast_Validation[]}}>}
 */
class DisplayBlockValidation extends Component {
    render() {
        const { errors, warnings } = this.props.validation
        if (errors.length === 0 && warnings.length === 0) return null

        return (
            <div style={{ position: "relative" }}>
                <DisplayCounter errors={errors} warnings={warnings} />
            </div>
        )
    }
}

DisplayBlockValidation.propTypes = {}

export default DisplayBlockValidation



// WEBPACK FOOTER //
// ./src/features/editor/block/DisplayBlockValidation.js